import React from "react";
import {
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import { DebounceInput } from "react-debounce-input";
import IconMagnifying from "../Icon/Magnifying.jsx";
import "./SearchBar.css";

function SearchBar(props) {
  return (
    <div className="navbar-search form-inline mr-3 d-none d-md-flex ml-lg-auto">
      <FormGroup className="mb-0">
        <InputGroup className="input-group-alternative">
          <InputGroupAddon addonType="prepend">
            <InputGroupText>
              <IconMagnifying className="size-5" />
            </InputGroupText>
          </InputGroupAddon>
          <DebounceInput
            placeholder="搜索"
            className="form-control"
            value={props.search_string}
            onChange={(e) => props.onSearchInputChange(e)}
            debounceTimeout={1000}
          />
        </InputGroup>
      </FormGroup>
    </div>
  );
}

export default SearchBar;
